const FeatureFlagService = require('./featureFlagService').default;

const moduleDeps = [require('data/user').name, require('data/model/client').name];

module.exports = angular
  .module('bench.data.service.featureFlagService', moduleDeps)
  .service('featureFlagService', FeatureFlagService);
